import { TenantTierEnum } from "@finway-group/shared/lib/models/featureFlags/tenantTier.enum"
import React from "react"
import { useTranslation } from "react-i18next"
import { Col, Radio, Row, Tabs } from "antd"

import { PriceIntervalEnum } from "@finway-group/shared/lib/models"
import PaymentSubscriptionUpdateCard from "./paymentSubscriptionUpdateCard"
import useStateIfMounted from "Shared/utils/hooks/useStateIfMounted"
import TierIcon from "Components/icons/tierIcon"
import { PaymentProductUI } from "Shared/services/paymentSettings.service"

type TenantTierPaidEnum = Exclude<TenantTierEnum, TenantTierEnum.FREE>

interface PaymentSubscriptionUpdateSelectInterface {
    plan?: PaymentProductUI
    sortedPlans: PaymentProductUI[]
    intervalFilter?: PriceIntervalEnum
    tierSelection: TenantTierPaidEnum
    onGetAQuote: () => void
    renderPlanCard: (plan: any, price: any) => JSX.Element
}

const PaymentSubscriptionUpdateSelect: React.FC<PaymentSubscriptionUpdateSelectInterface> = ({ plan, sortedPlans, intervalFilter, tierSelection, onGetAQuote, renderPlanCard }) => {
    const { t } = useTranslation()
    const [activeKey, setActiveKey] = useStateIfMounted(!intervalFilter ? PriceIntervalEnum.MONTHLY.toString() : intervalFilter.toString())

    const renderTabContent = (priceInterval: PriceIntervalEnum) => {
        return (
            <>
                <Row className="mb-30">
                    <Col span={3}>
                        <div className={`flex items-center justify-center h-50 w-50 rounded`} style={{ border: `1px solid rgba(235, 239, 242, 1)` }}>
                            <TierIcon tier={tierSelection} />
                        </div>
                    </Col>
                    <Col span={11}>
                        <h1 className="text-3xl ">{t(`label:payment_settings.tier.${tierSelection}.title`)}</h1>
                        <p>{t(`label:payment_settings.tier.${tierSelection}.description`)}</p>
                    </Col>
                    <Col span={10}>
                        {!intervalFilter && (
                            <div className="card-modal">
                                <Radio.Group value={activeKey} onChange={(e) => setActiveKey(e.target.value)} disabled={!!intervalFilter}>
                                    <Radio.Button value={PriceIntervalEnum.YEARLY.toString()}>
                                        {t(`label:payment_settings.intervals.${PriceIntervalEnum[PriceIntervalEnum.YEARLY].toLowerCase()}`)}
                                    </Radio.Button>
                                    <Radio.Button value={PriceIntervalEnum.MONTHLY.toString()}>
                                        {t(`label:payment_settings.intervals.${PriceIntervalEnum[PriceIntervalEnum.MONTHLY].toLowerCase()}`)}
                                    </Radio.Button>
                                </Radio.Group>
                            </div>
                        )}
                    </Col>
                </Row>
                <PaymentSubscriptionUpdateCard
                    spanIcon={2}
                    spanName={16}
                    name={t("label:payment_settings.enterprise")}
                    unitPrefixText={t("input:payment_settings.more_than")}
                    units={Number(sortedPlans.length > 0 ? sortedPlans[0].metadata.units : plan?.metadata.units)}
                    isPriceAvailable={false}
                    spanButton={6}
                    buttonText={t("action:payment_settings.get_a_quote")}
                    onClick={onGetAQuote}
                />
                {sortedPlans.map((plan) => {
                    const price = plan.prices?.find((price) => price.interval === priceInterval)
                    return renderPlanCard(plan, price)
                })}
            </>
        )
    }

    const tabs = [
        <Tabs.TabPane
            tab={t(`label:payment_settings.intervals.${PriceIntervalEnum[PriceIntervalEnum.MONTHLY].toLowerCase()}`)}
            key={PriceIntervalEnum.MONTHLY.toString()}
            className="pb-10"
        >
            {renderTabContent(PriceIntervalEnum.MONTHLY)}
        </Tabs.TabPane>,
        <Tabs.TabPane
            tab={t(`label:payment_settings.intervals.${PriceIntervalEnum[PriceIntervalEnum.YEARLY].toLowerCase()}`)}
            key={PriceIntervalEnum.YEARLY.toString()}
            className="pb-10"
        >
            {renderTabContent(PriceIntervalEnum.YEARLY)}
        </Tabs.TabPane>,
    ]

    return (
        <Tabs activeKey={activeKey} onChange={(key) => setActiveKey(key)} renderTabBar={() => <></>}>
            {intervalFilter ? tabs.filter((e) => e.key === intervalFilter.toString()).map((e) => e) : tabs.map((e) => e)}
        </Tabs>
    )
}

export default PaymentSubscriptionUpdateSelect
